<template>
  <v-bottom-sheet v-model="isShown" style="z-index: 1000;">
    <v-sheet height="200px">
      <div class="bottom-sheet_header" @click="$emit('hide-sheet', false)">
        <span>Close</span>
      </div>
      <div class="bottom-sheet_wrapper">
        <v-card
          elevation="0"
          class="bottom-sheet_card first_card"
          color="light-blue darken-4"
          dark
          tile
          @click="copyCoords"
        >
          <p>
            Copy coordinates of <br />
            current location
          </p>
        </v-card>
        <!-- <v-card
          elevation="0"
          tile
          class="bottom-sheet_card"
          color="light-blue darken-4"
          dark
          @click="$emit('add-meet-with-coords', data)"
        >
          <p>
            Add new meet from <br />
            this location
          </p>
        </v-card> -->
        <v-dialog
          v-model="facilityDialog"
          :retain-focus="false"
          max-width="700px"
          persistent
        >
          <template v-slot:activator="{ on, attrs }">
            <v-card
              elevation="0"
              tile
              class="bottom-sheet_card"
              color="light-blue darken-4"
              dark
              v-on="on"
              v-bind="attrs"
            >
              <p>
                Add new facility <br />
                from this location
              </p>
            </v-card>
            <!-- <v-btn
              outlined
              color="light-blue darken-4"
              dark
              v-bind:attrs="attrs"
              v-on="on"
            >
              Add facility
            </v-btn> -->
          </template>
          <FacilityForm @close-form="closeForm" :latLng="data" />
        </v-dialog>
      </div>
    </v-sheet>
  </v-bottom-sheet>
</template>
<script>
import FacilityForm from "@/components/forms/facilityForm.vue";

export default {
  components: { FacilityForm },
  props: {
    showBottomSheet: {
      type: Boolean,
      required: true
    },
    data: {
      type: [Object, Boolean]
    }
  },
  data() {
    return {
      facilityDialog: false
    };
  },
  computed: {
    isShown: {
      get() {
        return this.showBottomSheet;
      },
      set(val) {
        this.$emit("hide-sheet", val);
      }
    }
  },
  methods: {
    copyCoords() {
      navigator.clipboard
        .writeText(`${this.data.latitude}, ${this.data.longitude}`)
        .then(() => {
          this.$toast.success(
            "Coordinates of current location has been copied"
          );
        })
        .catch(error => {
          console.error(error);
          this.$toast.error("Something went wrong");
        });
    },
    closeForm() {
      this.facilityDialog = false;
      this.$emit("hide-sheet", false);
    }
  }
};
</script>
<style lang="scss">
.bottom-sheet {
  &_header {
    width: 100%;
    background-color: #ef5350;
    color: white;
    text-align: center;
    padding: 10px 20px;
    font-size: 20px;
    font-weight: bold;
    transition: all 0.3s;
    cursor: pointer;
  }
  &_header:hover {
    box-shadow: 0 0 7px #d32f2f;
  }
  &_wrapper {
    height: 100%;
    padding-bottom: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .v-card:hover {
      background-color: white !important;
      color: #01579b;
    }

    div {
      height: 100%;
      width: (99.8% / 2);
    }
  }
  &_card {
    transition: all 0.3s;
    display: flex;
    align-items: center;
    border-left: 1px solid white !important;

    p {
      width: 100%;
      padding: 15px 20px;
      font-weight: bold;
      font-size: 25px;
      text-align: center;
      word-wrap: break-word;
    }
  }
  &_card:hover {
    background-color: white !important;
  }
}
</style>
